import React, { useState } from "react";
import "./Collaborations.scss";

const Collaborations = () => {
  const [activeDepartment, setActiveDepartment] = useState("animation");

  const departments = [
    {
      name: "Molecular Medicine and Haematology Department",
      description:
        "The Department of Molecular Medicine and Haematology at WITS, in collaboration with the NHLS, focuses on understanding, diagnosing, and treating diseases at a molecular level, particularly blood disorders, infections, and cancer. With a strong presence in major teaching hospitals, the mainision integrates clinical diagnostics, cutting-edge research, and specialized training to advance medical science and improve patient care in South Africa and beyond.",
    },
    {
      name: "Digital Arts Department",
      description:
        "At the Digital Arts Department, creativity and technology merge to shape tomorrow’s digital innovators. Our cutting-edge programs in Animation, Game Design, and Interactive Media empower students to master technical skills, embrace critical theory, and unleash artistic vision. Graduates emerge as versatile leaders ready to disrupt traditional industries and drive creative change across the digital landscape.",
    },
    {
      name: "Audiology Department",
      description:
        "The Department of Speech Pathology and Audiology at the University of the Witwatersrand (Wits) is a leader in auditory research and clinical practice, offering comprehensive undergraduate and postgraduate programs. The department emphasizes practical training through its Speech and Hearing Clinic and various affiliated facilities. ",
    },
    {
      name: "School of Education",
      description:
        "​The Wits School of Education (WSoE), established in 1909, is renowned for its world-class research and high-quality teaching. It offers a range of undergraduate and postgraduate programs designed to equip educators with the skills to make a meaningful impact. The School also houses research centers such as the Centre for Researching Education and Labour (REAL), the Hub for Multilingual Education and Literacies (HuMEL), and the Centre for Deaf Studies, contributing to impactful educational research and practice.",
    },
  ];

  const toggleDepartment = (name) => {
    setActiveDepartment(activeDepartment === name ? null : name);
  };

  return (
    <main className="collaborations-page">
      <header className="collaborations-header">
        <h1>Collaborations & Opportunities</h1>
      </header>

      <section className="collaborations-section">
        <h2>Our Collaborations</h2>
        <p>
          At GAIC Lab, we collaborate with various schools within Wits
          University on groundbreaking research projects. Our interdisciplinary
          approach allows us to push the boundaries of AI, gaming, and culture.
        </p>
        <ul>
          {departments.map((dept) => (
            <li key={dept.name} onClick={() => toggleDepartment(dept.name)}>
              {dept.name}
              {activeDepartment === dept.name && (
                <p className="department-description">{dept.description}</p>
              )}
            </li>
          ))}
        </ul>
      </section>

      <section className="opportunities-section">
        <h2>Join the GAIC Lab</h2>
        <p>
          We are currently recruiting! If you’re passionate about game design,
          AI, and cultural studies, explore our research projects and become a
          part of our lab.
        </p>
      </section>

      <main className="recruitment-adverts">
        <main className="advert south-africa-ad">
          <h3>Investigating the South African Animation Pipeline</h3>
          <p>
            We are researching how South African animators adapt their
            production and distribution pipelines to release content. Please
            reach out, Your insights will help us understand local approaches
            and their stylistic impact.
          </p>
          <>
            <p>
              <strong>Researchers:</strong> Rachel van Rooyen, Japheth Mandela
              <br />
              <strong>Supervision:</strong> Dr. Olu Randle
            </p>
            <a href="https://gaiclab.co.za/people">Meet the GAIC Team</a>
            <form
              action="https://formsubmit.co/witsgaiclab@gmail.com"
              method="POST"
            >
              <label>Email:</label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                required
              />
              <label>Name and Surname:</label>
              <input
                type="name"
                name="name"
                placeholder="Enter your name and surname"
                required
              />
              <input type="hidden" name="_captcha" value="false" />
              <input
                type="hidden"
                name="_subject"
                value="New Research Interest Submission"
              />
              <input
                type="hidden"
                name="_next"
                value="https://gaiclab.co.za/collab"
              />
              <input
                type="hidden"
                name="formName"
                value="South African Animation Research"
              />
              <button type="submit">Join the Research</button>
            </form>
          </>
        </main>

        <main className="advert">
          <h4>
            Investigating the possibilities of using Artificial Intelligence in
            Fostering Collaboration in the Animation Pipeline in Kenya
          </h4>
          <p>
            We are researching how artificial intelligence (AI) can improve
            collaboration in the Kenyan animation industry. The goal is to
            examine AI tools and workflows that boost teamwork, efficiency, and
            production processes.
          </p>
          <p>
            <strong>Lead Researcher:</strong> Japheth Mandela
            <br />
            <strong>Supervision:</strong> Dr. Olu Randle
          </p>
          <a href="https://gaiclab.co.za/people">Meet the GAIC Team</a>
          <form
            action="https://formsubmit.co/witsgaiclab@gmail.com"
            method="POST"
          >
            <label>Email:</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              required
            />
            <input type="hidden" name="_captcha" value="false" />
            <input
              type="hidden"
              name="_subject"
              value="New Research Interest Submission"
            />
            <input
              type="hidden"
              name="_next"
              value="https://gaiclab.co.za/collab"
            />
            <input
              type="hidden"
              name="formName"
              value="Kenya Animation Research"
            />
            <button type="submit">Join the Research</button>
          </form>
          {/* <form>
            <label>Email:</label>
            <input type="email" placeholder="Enter your email" required />
            <button type="submit">Join the Research</button>
          </form> */}
        </main>
      </main>
    </main>
  );
};

export default Collaborations;
